import { atom } from "jotai";
import { DateRange } from "../helpers/types";

const now = new Date();
const sixHoursAgo = new Date(now.getTime() - 6 * 3_600_000);

export const dateRangeAtom = atom<DateRange>({
  from: sixHoursAgo,
  to: now,
}); 